'use client';

import React from 'react';
import Link from 'next/link';
import { useRegionPricing } from '@/features/payment/hooks/useRegionPricing';

interface MobileStickyCTAProps {
    isVisible: boolean;
}

export default function MobileStickyCTA({ isVisible }: MobileStickyCTAProps) {
    const { priceText } = useRegionPricing();

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 p-4 bg-white/95 backdrop-blur-md border-t border-gray-200 z-50 lg:hidden shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
            <Link
                href="/signup"
                className="w-full flex items-center justify-center gap-2 px-6 py-3.5 bg-violet-600 text-white font-semibold text-base rounded-xl active:scale-[0.98] transition-all shadow-lg shadow-violet-600/20 hover:bg-violet-700"
            >
                Start Building Free
                {/* <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg> */}
            </Link>
            {/* <p className="text-center text-xs text-gray-900 mt-2">
                Free to build. {priceText} one-time to publish.
            </p> */}
        </div>
    );
}
